(function () {
  initializeUtilsFunctions();
  executeOnce('modal-share', function () {
    function shareButton() {
      const shareBtns = document.querySelectorAll('#share-content-page');
      const modalShare = document.querySelector('.modal-share');
      if (shareBtns) {
        shareBtns.forEach(function (shareBtn) {
          shareBtn.addEventListener('click', function () {
            modalShare.classList.add('active');
            if (document.querySelector('.modal-bg')) {
              document.querySelector('.modal-bg').classList.add('active');
            }
          });
        });
      }
    }

    function copyUrl() {
      const copyBtn = document.querySelector('#copyUrl');
      if (copyBtn) {
        copyBtn.addEventListener('click', function (e) {
          const el = document.createElement('textarea');
          el.value = sanitizeUri(window.location.href);
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          e.stopPropagation();
        });
      }
    }

    function sendMailUrl() {
      const sendMailUrlBtn = document.querySelector('#sendMailUrl');
      if (sendMailUrlBtn) {
        sendMailUrlBtn.addEventListener('click', function () {
          const link = "mailto:?subject=&body=" + sanitizeUri(window.location.href);
          location.assign(sanitizeUri(link));
        });
      }
    }

    function shareWithFacebook() {
      const fb = document.querySelector('#share-with-facebook');
      if (fb) {
        // <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button_count&size=small&width=127&height=20&appId" width="127" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        fb.addEventListener('click', (e)=> {
          const button = document.createElement('button');
          button.setAttribute('data-href', sanitizeUri(window.location.href));
          button.innerHTML = '<a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=' + window.location.href.replace(/[/]/g, "%2F") + '&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">Condividi</a>';
          document.querySelector('body').appendChild(button);
          button.querySelector('a').click();
          setTimeout(()=> {
            button.parentNode.removeChild(button);
          }, 3000)
        })
      }
    }

    function shareWithTwitter() {
      const twitter = document.querySelector('#share-with-twitter');
      if (twitter) {
        // <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button_count&size=small&width=127&height=20&appId" width="127" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        twitter.addEventListener('click', (e)=> {
          const link = document.createElement('a');
          link.setAttribute('href', 'https://twitter.com/intent/tweet?text=' + window.location.href);
          link.setAttribute('target', '_blank');
          document.querySelector('body').appendChild(link);
          link.click();
          setTimeout(()=> {
            link.parentNode.removeChild(link);
          }, 3000)
        })
      }
    }

    function shareWithWhatsapp() {
      const w = document.querySelector('#share-with-whatsapp');
      if (w) {
        // <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button_count&size=small&width=127&height=20&appId" width="127" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        w.addEventListener('click', (e)=> {
          const link = document.createElement('a');
          link.setAttribute('href', 'https://api.whatsapp.com/send?phone=whatsappphonenumber&text=' + window.location.href);
          link.setAttribute('target', '_blank');
          document.querySelector('body').appendChild(link);
          link.click();
          setTimeout(()=> {
            link.parentNode.removeChild(link);
          }, 3000)
        })
      }
    }
    shareWithWhatsapp();
    shareWithTwitter();
    shareWithFacebook();
    shareButton();
    copyUrl();
    sendMailUrl();
  });
}());


